# What a card of the proposals Drawer shows of a proposal. Selecting `affectedDimensions` or
# `changes` makes the backend compute the diff against the current schedule, so only the Drawer
# selects these fields.
fragment ProposalListFields on AssignmentProposal {
  id
  status
  createdAt
  createdBy {
    username
    name
    lastName
    __typename
  }
  requestedReviewers {
    username
    name
    lastName
    __typename
  }
  affectedDimensions
  changes {
    op
    sessionId
    schedule {
      old
      new
      __typename
    }
    weeks {
      ...ProposalChangeSetFields
      __typename
    }
    classrooms {
      ...ProposalChangeSetFields
      __typename
    }
    instructors {
      ...ProposalChangeSetFields
      __typename
    }
    __typename
  }
}

fragment ProposalChangeSetFields on AssignmentProposalChangeSet {
  added {
    id
    code
    name
    __typename
  }
  removed {
    id
    code
    name
    __typename
  }
}
